import React, { useEffect, useState, useRef } from "react"
import { ChromePicker } from "react-color"

import useClickOutside from "../../../hooks/useClickOutside"
import Input from "../../atoms/Input"
import styles from "./index.module.scss"

function ColorSquare(props) {
  const { color, ...rest } = props

  return (
    <div
      className={styles.colorSquare}
      style={{ background: color }}
      {...rest}
    />
  )
}

const ColorPicker = React.forwardRef((props, ref) => {
  const { value, onChange, disabled, ...rest } = props

  const [color, setColor] = useState(value || "#000000")
  const [open, setOpen] = useState(false)

  const containerRef = useRef(null)

  useEffect(() => {
    setColor(value || "#000000")
  }, [value])

  const handleOnChange = (data) => {
    setColor(data.hex)
    onChange?.(data.hex)
  }

  const handleToggle = () => setOpen(open ? false : true)

  useClickOutside(containerRef, () => setOpen(false))

  return (
    <div className={styles.container} ref={containerRef}>
      <Input
        ref={ref}
        readonly={true}
        onFocus={handleToggle}
        iconLeft={<ColorSquare color={color} onClick={handleToggle} />}
        disabled={disabled}
        value={color}
        {...rest}
      />
      {open && !disabled && (
        <div className={styles.pickerContainer}>
          <ChromePicker disableAlpha color={color} onChange={handleOnChange} />
        </div>
      )}
    </div>
  )
})

ColorPicker.displayName = "ColorPicker"

export default ColorPicker
